export default "__VITE_ASSET__CgAuXsSx__"